import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { Subscription } from 'rxjs';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';


@Component({
    selector: 'vg-theatre-mode',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="icon"
             [class.vg-icon-theatre-mode]="!isTheatremode"
             [class.vg-icon-theatre-mode_exit]="isTheatremode"
             tabindex="0"
             role="button"
             aria-label="theatre mode button"
             [attr.aria-valuetext]="ariaValue">
        </div>`,
    styles: [ `
        vg-theatre-mode {
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            display: flex;
            justify-content: center;
            height: 50px;
            width: 40px;
            cursor: pointer;
            color: white;
            line-height: 50px;
            margin-left: 15px;
        }

        vg-theatre-mode .vg-icon-theatre-mode:before{
            
            content: '';
            border: 2px solid white;
            width: 22px;
            height: 14px; 
        
        }

        vg-theatre-mode .vg-icon-theatre-mode_exit:before{
            
            content: '';
            border: 2px solid white;
            width: 17px;
            height: 8px; 
        
        }

        vg-theatre-mode .icon {
            pointer-events: none;
        }
    ` ]
})
export class VgTheatreMode implements OnInit, OnDestroy {
    elem: HTMLElement;
    vgFor: string;
    target: Object;
    isTheatremode: boolean = false;

    subscriptions: Subscription[] = [];

    ariaValue = 'normal mode';

    constructor(ref: ElementRef, public API: VgAPI, private interactions: EventInteraction) {
        this.elem = ref.nativeElement;
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
    }

    onChangeTheatremode(fsState: boolean) {
        this.ariaValue = fsState ? 'theatre mode' : 'normal mode';
        this.isTheatremode = fsState;
    }

    @HostListener('click')
    onClick() {
        this.changeTheatremodeState();
    }

    changeTheatremodeState(fireInteraction:boolean = true) {
        let element = this.target;

        if (this.target instanceof VgAPI) {
            element = null;
        }

        this.onChangeTheatremode(!this.isTheatremode);

        if (fireInteraction) {
            this.interactions.next({ key: "theatremode", message: { theatre: this.isTheatremode } });
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-theatre-mode/vg-theatre-mode.component.ts